import { BarChart3, Clock3, Home, Sparkles, UserRound } from 'lucide-react'

export type TabKey = 'today' | 'history' | 'progress' | 'coach' | 'profile'

const items = [
  { key: 'today' as const, label: 'Hoy', Icon: Home },
  { key: 'history' as const, label: 'Sesiones', Icon: Clock3 },
  { key: 'progress' as const, label: 'Progreso', Icon: BarChart3 },
  { key: 'coach' as const, label: 'Coach', Icon: Sparkles },
  { key: 'profile' as const, label: 'Perfil', Icon: UserRound },
]

export function BottomNav({ selected, onSelect }: { selected: TabKey; onSelect: (tab: TabKey) => void }) {
  return (
    <nav className="bottom-nav" aria-label="Navegación principal">
      {items.map(({ key, label, Icon }) => (
        <button
          className={selected === key ? 'nav-item selected' : 'nav-item'}
          key={key}
          onClick={() => onSelect(key)}
          aria-current={selected === key ? 'page' : undefined}
        >
          <Icon size={21} strokeWidth={selected === key ? 2.6 : 1.8} fill={selected === key ? 'currentColor' : 'none'} />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  )
}
